import React from "react";

import { cx } from "~/tools/class-variance";

export interface TableHeadCellButtonProps extends React.ComponentPropsWithoutRef<"button"> {
	isSelected: boolean;
	isHighlighted?: boolean;
	children: React.ReactNode;
}

export const TableHeadCellButton = React.forwardRef<React.ComponentRef<"button">, TableHeadCellButtonProps>(
	({ className, isSelected: isActive, isHighlighted, ...props }, ref) => (
		<button
			aria-pressed={isHighlighted}
			aria-selected={isActive}
			className={cx(
				"-m-0.5 flex select-none items-center justify-center rounded-sm p-1 text-gray-500 ring-gray-500 transition-shadow",
				"hover:ring-1",
				"focus-visible:ring-1",
				"aria-pressed:ring-1",
				"aria-selected:bg-gray-600 aria-selected:text-white aria-selected:ring-gray-600",
				className,
			)}
			ref={ref}
			type="button"
			{...props}
		/>
	),
);
